module.exports = __webpack_public_path__ + "static/img/sbktext2.1761547470324.png";